import DOMPurify from 'dompurify';

export const truncateText = (text, size) => {
    let textData = removeHtmlTagsFromParagraph(text);
    return textData.length > size ? textData.slice(0, size - 1) + '…' : textData;
};

export const placeholderLabel = (label) => {
    return 'Select ' + (label ? ' a ' + label?.toLocaleLowerCase() : 'an option');
};

export const vueTreeSelectPlaceholderLabel = (label) => {
    return 'Type here to search ' + label;
};

export const getFullName = (user) => {
    let fullname = null;
    if (user) {
        fullname = user.id === 1 ? 'System Admin' : user.name + ' ' + user.surname;
    }
    return fullname;
};

export const toCapitalize = (stringVal) => {
    return stringVal
        .split(' ')
        ?.map((obj) => {
            let word = obj.charAt(0).toUpperCase() + obj.slice(1);
            return word;
        })
        .join(' ');
};

// Removes unnecessary scripts that might be harmful from a paragraph
export const sanitizeHtmlText = (dirtyParagraph) => {
    return DOMPurify.sanitize(dirtyParagraph);
};

// Removes all the html tags from a paragraph
export const removeHtmlTagsFromParagraph = (paragraph) => {
    const cleanedText = sanitizeHtmlText(paragraph);
    return cleanedText?.replace(/<\/?[^>]+(>|$)/g, '');
};

export const generateRandomNumbers = (n, targetSum) => {
    if (typeof n !== 'number' || n <= 0 || typeof targetSum !== 'number' || targetSum <= 0) {
        console.log('Invalid parameters. Please provide positive numbers greater than 0.');
    }

    const randomNumbers = [];

    // Generate n numbers
    for (let i = 0; i < n; i++) {
        const maxPossibleNumber = targetSum - randomNumbers.reduce((sum, num) => sum + num, 0);
        const randomNumber = Math.floor(Math.random() * Math.min(100, maxPossibleNumber)) + 1;
        randomNumbers.push(randomNumber);
    }

    return randomNumbers;
};

export const calPercentChange = (firstVal, secondVal) => {
    // Calculate the percentage change
    if (firstVal === 0) {
        firstVal = 1;
    }
    const percentageChange = ((firstVal - secondVal) / Math.abs(firstVal)) * 100;

    // Determine whether it's an increase or decrease
    const changeType = percentageChange > 0 ? 'increase' : 'decrease';

    return {
        percentage: Math.abs(percentageChange).toFixed(0),
        changeType: changeType,
    };
};
